import { render, staticRenderFns } from "./OwnerBaseData.vue?vue&type=template&id=02e1b42e"
import script from "./OwnerBaseData.vue?vue&type=script&lang=js"
export * from "./OwnerBaseData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports